import API from "../api";

export async function createBasePayment({ product, email }) {
  try {
    const p =
      email
        ? { ...product, recipient: { ...(product?.recipient || {}), email } }
        : product;

    const res = await API.post("/base/create", { product: p });
    const data = res.data;

    if (data == null) throw new Error("Base returned an empty response.");
    if (typeof data === "string") throw new Error(`Base returned non-JSON: ${data.slice(0, 200)}`);
    if (data.error) throw new Error(data.message || "Base returned an error");

    return data;
  } catch (err) {
    const status = err?.response?.status;
    let msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to create Base payment";

    const needsLogin =
      status === 401 || status === 403 ||
      msg.includes("Missing auth token") ||
      msg.includes("Unauthorized") ||
      msg.includes("jwt expired") ||
      msg.includes("invalid token");

    const e = new Error(needsLogin ? "Please log in to continue." : msg);
    e.code = needsLogin ? "AUTH" : "BASE_CREATE";
    throw e;
  }
}

export async function confirmBasePayment({ txnId, txHash }) {
  try {
    const res = await API.post("/base/confirm", { txnId, txHash });
    const data = res.data;

    if (!data || data.error) {
      throw new Error(data?.message || data?.error || "Base confirm returned an unexpected response");
    }

    return data;
  } catch (err) {
    const status = err?.response?.status;
    let msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to confirm Base payment";

    const needsLogin =
      status === 401 || status === 403 ||
      msg.includes("Missing auth token") ||
      msg.includes("Unauthorized") ||
      msg.includes("jwt expired") ||
      msg.includes("invalid token");

    const e = new Error(needsLogin ? "Please log in to continue." : msg);
    e.code = needsLogin ? "AUTH" : "BASE_CONFIRM";
    throw e;
  }
}
